import axios from 'axios';

import Environment from '@/environment';
import { tracking } from '@/helpers/track-event';
import { useAppStore } from '@/store/app';
import { useAuthStore } from '@/store/auth';

axios.defaults.baseURL = Environment.API_URL;

export default function Axios() {
  return {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    install: () => {
      const authStore = useAuthStore();
      const appStore = useAppStore();
      axios.interceptors.response.use(undefined, async function (error) {
        const status = error.response && error.response.status;
        const requestedURL =
          error.response && error.response.config && error.response.config.url;

        if (status === 401 && requestedURL !== '/auth/logout') {
          tracking.reset();
          await authStore.logout();
          // todo: redirect to home

          return;
        }

        if (
          status === 426 &&
          requestedURL !== '/status' &&
          !window.location.href.includes('/update')
        ) {
          await appStore.setNeedsUpdate(true);
          window.location.href = '/update';
        }

        return Promise.reject(error);
      });

      axios.interceptors.request.use((config: Record<string, any>) => {
        config.headers['ngrok-skip-browser-warning'] = true;

        const buildVersion = appStore.info.build;

        if (buildVersion) {
          config.headers['X-Build-Version'] = buildVersion;
        }

        const appVersion = appStore.info.version;

        if (appVersion) {
          config.headers['X-App-Version'] = appVersion;
        }

        const appPackage = appStore.info.package;

        if (appPackage) {
          config.headers['X-App-Package'] = appPackage;
        }

        const platform = appStore.platform;

        if (platform) {
          config.headers['X-Platform'] = platform;
        }

        const token = authStore.token;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      });
    },
  };
}
